/**
 * i18n bootstrap — ProcureX portal.
 * EN baseline + HI/ES stubs. Suppliers can switch language from the portal header
 * (deferred wiring — the engine is ready to be consumed).
 *
 * Usage in any component:
 *   import { useTranslation } from 'react-i18next';
 *   const { t } = useTranslation();
 *   <span>{t('portal.profile.completeness')}</span>
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import hi from './locales/hi.json';
import es from './locales/es.json';

const stored = (typeof window !== 'undefined' && window.localStorage)
  ? localStorage.getItem('procurex-lang') : null;

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hi: { translation: hi }, es: { translation: es } },
  lng: stored || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
